import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Ng1TranslateService } from '../ng1-translate.service';
import { LanguageService } from '../services/language.service';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'cc-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  public isChannels: boolean;

  constructor(
    public translate: TranslateService,
    private ng1TranslateService: Ng1TranslateService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.isChannels = document.location.origin === environment.CHANNELS_URL;
  }

  useAndUpdateLang(lang) {
    this.useLanguage(lang);
    this.updateUserLanguage(lang);
    this.languageService.setCookieLanguage(lang);
    this.languageService.setChartsLanguage();
  }

  useLanguage(lang) {
    this.languageService.use(lang);
    this.ng1TranslateService.use(lang);
    moment.locale(lang);
  }

  updateUserLanguage(lang) {
    this.ng1TranslateService.patchLang({ language: lang });
  }

  filterTranslations(lang) {
    return this.translate.getLangs().filter(value => value !== lang);
  }
}
